import React from 'react';
import propTypes from 'prop-types';

const Spinner = ({ hintText, type, colorTypes = 'primary' }) => {
  return (
    <>
      {hintText && !!hintText.length && (
        <div className="text-center mb-3">
          <div>{hintText}</div>
        </div>
      )}

      {type === Spinner.types.wave && (
        <div className="py-4">
          <div className={`hb-spinner mx-auto hb-spinner-${colorTypes}`} />
        </div>
      )}

      {type === Spinner.types.circle && (
        <div className="d-flex flex-row justify-content-center">
          <div className={`spinner-border text-${colorTypes}`} role="status" />
        </div>
      )}
    </>
  );
};

Spinner.types = {
  wave: 'wave',
  circle: 'circle',
};

Spinner.colorTypes = {
  wave: 'primary',
  circle: 'light',
};

Spinner.propTypes = {
  hintText: propTypes.string,
  type: propTypes.string.isRequired,
};

export default Spinner;
